/**
 * =============================================================================
 * USE SEO — Hook para obter metadados da página atual
 * =============================================================================
 *
 * Devolve os metadados configurados em src/config/seo.ts para o pathname
 * ativo. Permite sobrescrever título, descrição ou schema.
 */

import { useLocation } from "react-router-dom";
import { getPageSeo, type PageSeo } from "@/config/seo";

export function useSeo(): PageSeo {
  const location = useLocation();
  return getPageSeo(location.pathname);
}
